export enum MethodRequest {
    Get = "GET",
    Head = "HEAD",
    Post = "POST",
    Options = "OPTIONS",
    Put = "PUT",
    Patch = "PATCH",
    Purge = "PURGE",
    Unlink = "UNLINK",
    Delete = "DELETE"
}